module.exports = __webpack_public_path__ + "static/img/banner_rczp.c6ecbff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/banner_rczp.png
// module id = 9Uig
// module chunks = 1